/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useQuery, useReactiveVar } from '@apollo/client';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import Loader from 'views/Shared/components/Loader';
import { GET_FAILED_TEST_RESULTS_FOR_FRY7Q, GET_RULE_AUDIT_LOGS_FOR_FRY7Q } from 'Apollo/Queries/Rules/Fry7qResults';
import {
    leftNavigationItemsVar, moduleIdVar, showReportMenuVar, currentLeftMenuVar, tenantIdVar,
} from 'Apollo/config';
import { ModuleEnum } from 'constants';
import crossReportImg from 'assets/images/cross-report-black.svg';
import FRY7QResults from '../components/FRY7QResults';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem', color: '#464646' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const FRY7QResultsContainer = () => {
    const location = useLocation();
    const history = useHistory();
    const [batchId, setBatchId] = useState(location.state.batchId);
    const [period, setPeriod] = useState(location.state.period);
    const [ruleId, setRuleId] = useState(location.state.ruleId);
    const tenantId = useReactiveVar(tenantIdVar);

    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.RULEENGINE);
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setBatchId(location.state.batchId);
        setPeriod(location.state.period);
        setRuleId(location.state.ruleId);
        showReportMenuVar(true);
    }, [location]);

    /* Apollo query to fetch audit logs */
    const auditLog = useQuery(GET_RULE_AUDIT_LOGS_FOR_FRY7Q, {
        variables: {
            input: {
                batchId: Number(batchId),
                ruleId: Number(ruleId),
                tenantId: Number(tenantId),
            },
        },
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to fetch failed test data */
    const {
        loading, error, data: failedTestsData = {}, refetch,
    } = useQuery(GET_FAILED_TEST_RESULTS_FOR_FRY7Q, {
        variables: {
            input: {
                tenantId: Number(tenantId),
                batchId: Number(batchId),
                ruleId: Number(ruleId),
                period,
            },
        },
        fetchPolicy: 'no-cache',
    });

    const { getFailedTestResultsForFRY7Q: { remediation } = {} } = failedTestsData;
    const { getFailedTestResultsForFRY7Q: { criteria, testResults } = {} } = failedTestsData;

    const failedTestResults = testResults && testResults.map(result => ({
        testPass: result.testPass,
        testFail: result.testFail,
        testDate: moment(result.testDate).format('LL'),
        remediationCount: result.remediationCount,
        errorData: result.errorData ? result.errorData.replace('[[', '[').replace(']]', '').replace('[', '').replaceAll(' [', '')
            .split('],') : result.errorData,
        errorMessage: result.errorMessage ? result.errorMessage.split(',') : result.errorMessage,
    }));

    if (loading) {
        return <Loader />;
    }
    if (error) {
        return <div>Error</div>;
    }

    /* Method for side navigation */
    const onNavigate = () => {
        // sidebar navigation
    };

    /* Breadcrumb items configuration */
    const breadcrumbItems = [
        {
            link: '',
            value: (
                <span
                    className="appkiticon icon-home-fill font-16"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.push('/');
                            leftNavigationItemsVar([]);
                            moduleIdVar(null);
                        }
                    }
                    role="presentation"
                />
            ),
        },
        {
            link: '',
            value: (
                <span
                    className="a-breadcrumb-item-text"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.goBack();
                        }
                    }
                    role="presentation"
                >
                    FRY7Q Diagnostic Results
                </span>
            ),
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">{`Rule #${criteria.ruleId} Results`}</span>,
        },
    ];

    return (
        <FRY7QResults
            breadcrumbItems={breadcrumbItems}
            auditLog={auditLog}
            failedTestsData={failedTestsData}
            onNavigate={onNavigate}
            refetch={refetch}
            period={period}
            remediation={remediation || []}
            criteria={criteria}
            failedTestResults={failedTestResults}
        />
    );
};

export default FRY7QResultsContainer;
